const win = window as any;
class WinContext {
    // tips 通用接口
    // 关闭窗口(不需要处理数据)
    close() {
        return win.close();
    }
    // 最小化
    minimizeWindow() {
        return win.minimizeWindow();
    }
    // 最大化
    maximizeWindow() {
        return win.maximizeWindow();
    }
    // 顶部拖拽
    startDragWindow() {
        return win.startDragWindow();
    }
    // 调用C++注册的 showMessage 函数
    showMessage(data) {
        return win.showMessage(JSON.stringify(data));
    }
    // 调用C++注册的 callCpp 函数并接收返回值
    callCpp(data) {
        let result = null;
        win.callCpp(JSON.stringify(data), (res) => {
            console.log("callCp函数：c++返回值==>", res);
            result = res;
        })
        return result;
    }

    // tips 调用C++注册的 WorkAiApi 函数
    /**
        * @param {string} dataType - 请求类型枚举
        *   - `get_client_env`                      获取客户端环境  
        *   - `client_open_url`                     打开浏览器  
        *   - `client_read_data`                    读取存储
        *   - `client_save_data`                    写入存储
        *   - `get_client_office_ver`               获取客户端 Office 版本信息
        *   - `client_exit`                         关闭软件（客户端处理数据）
        *   - `get_client_channel`                  获取渠道信息
        *   - `client_download_office_install`      下载安装Office
        *   - `client_download_install`             下载安装其他软件 请求参数 - { "name": "Aippt", "install": "https://plugin-public.aippt.cn/plugin-packages/yundong/AiPPT-Setup-2.0.5.0_yundongwin_10_39_45.exe", "silence_params": "/S", "install_type": 0 }
        *   - `set_client_mouse_down`               鼠标按下
        *   - `set_client_mouse_up`                 鼠标抬起
        *   - `set_client_mouse_move`               鼠标移动
        *   - `client_get_show_all_state`           获取是否展示全部功能状态
        *   - `cilent_set_show_all_state`           设置是否展示全部功能状态   "1" 展示全部功能， "0" 非 1 不展示全部功能
        *                                           注：当前前端未调用；如需启用，s2 要的是原始字符串 "1"，
        *                                           需像 client_download_office_install 那样跳过下方的 JSON.stringify
        * @param {object} [data]         - 请求携带的参数
    */
    WorkAiApi(dataType, data) {
        // 下载安装Office接口不转json
        data = dataType == "client_download_office_install" ? data : JSON.stringify(data);

        return new Promise((resolve, reject) => {
            try {
                win.WorkAiApi(dataType, data, (res: any) => {
                    if (!res?.length) return resolve(res);
                    // client_read_data 返回的是 base64 字符串，不是 JSON，解析失败时按原样返回
                    try {
                        resolve(JSON.parse(res));
                    } catch {
                        resolve(res);
                    }
                })
            } catch (err) {
                reject(err)
            }
        })
    }


    // tips 监听c++调用js
    /*
        ⚠️ 这是覆盖式赋值：window.WorkAiSetData 只有一个，后注册的会顶掉先注册的。
        业务代码请勿直接调用，统一走 utils/cefEvents.ts 的 onCefEvent 订阅（内部只注册一次，再按需分发）。

        目前 c 端会推的 msgType：
          - client_download_office_* / client_download_install_*   下载安装各阶段（InstallStore）
          - client_size_change                                     窗口尺寸变化，msg 为 WM_SIZE 常量：
                                                                   0 = SIZE_RESTORED，2 = SIZE_MAXIMIZED（AppStore）
    */
    WorkAiSetData(callback) {
        win.WorkAiSetData = callback;
    }
}
export default WinContext;
